
import type { Result } from '@empathybroker/tsclient-play/dist/models/search/result'
import type { PropType } from 'vue'
import type { ExplainMessages } from '../../models'
import { defineComponent } from 'vue'
import { ExplainUtils } from '../../utils'
import ResultCardFooter from '../result-card-footer.component.vue'

export default defineComponent({
  name: 'ExplainResultCardFooter',
  components: {
    ResultCardFooter,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    hovered: Boolean,
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-explain-result-card-footer',
    }
  },
  computed: {
    text(): string {
      if (ExplainUtils.isResultPinned(this.result)) {
        return this.messages.pinned.label
      }
      return this.messages.score.label
    },
    formattedScoreValue(): string | undefined {
      if (ExplainUtils.isResultPinned(this.result)) {
        return undefined
      }

      const mainSortCriteria = ExplainUtils.getResultScoreCriteria(this.result)
      if (mainSortCriteria) {
        let sortValue = mainSortCriteria.value
        if (!isNaN(Number(sortValue))) {
          sortValue = Number(sortValue)
        }
        return sortValue.toLocaleString(this.$epb.locale)
      }

      return undefined
    },
  },
})
